import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';
// --- external imports -----

import too7aProjection from '~/assets/images/main_screen/too7a.png';
import kakakProjection from '~/assets/images/main_screen/kakak.png';
import ahmetProjection from '~/assets/images/main_screen/ahmet.png';
import golofinProjection from '~/assets/images/main_screen/golofin.png';
import { characterSelectors } from '~/store';
import { removeNewLineCharacters } from '~/lib/helpers';
// --- internal imports -----

import Asset from './BaseAssets';
import PopupModalBase from './PopupModalBase';
import { CheckmarkBtn, Label } from './ModalAssets';
// --- local imports -----

const PORTRAIT_PROJECTIONS = {
	too7a: too7aProjection,
	kakak: kakakProjection,
	ahmet: ahmetProjection,
	golofin: golofinProjection,
};

function PowerModal(props) {
	const portrait = PORTRAIT_PROJECTIONS[props.characterSlug];
	const portraitAspectRatio = portrait.height / portrait.width;
	const scale = props.scale || 1;
	const { title, description } = props.characterPower;

	return (
		<PopupModalBase
			title="Powers"
			usePowerPanel={true}
			scale={scale}
			data-testid="power-modal"
		>
			<Asset.Img
				x={414 * scale}
				y={314 * scale}
				projection={{
					src: portrait?.src,
					width: 151,
					height: 151 * portraitAspectRatio
				}}
				scale={scale}
			/>
			<PowerText
				x={585 * scale}
				y={300 * scale}
				projection={{
					width: 363 * scale,
					height: 200 * scale
				}}

				fontSize={19 * scale}
				data-testid="confirm-power-modal-text"
			>
				<div>
					{title && (
						<p>
							{removeNewLineCharacters(title)}
						</p>
					)}
					{description && (
						<>
							<br />
							<p>
								**{removeNewLineCharacters(description)}**
							</p>
						</>
					)}
				</div>
			</PowerText>
			<CheckmarkBtn
				x={853 * scale}
				y={494 * scale}
				scale={scale}
				onClick={props.onClose}
				data-testid="power-modal-ok-btn"
			/>
		</PopupModalBase>
	);
}

const PowerText = styled(Label)`
	display: flex;
	place-items: center;
`;

function mapStoreStateToProps(storeState) {
	return {
		characterPower:
			characterSelectors.getSelectedCharacterPower(storeState),
		characterSlug: characterSelectors.getSelectedCharacterSlug(storeState)
	};
}

export default connect(mapStoreStateToProps)(PowerModal);
